<form [formGroup]="form" (ngSubmit)="formService.submit()">

    <div class="page_title">

        <div class="row marges">

            <div class="col y_items_center">
                <h1 class="title">{{ 'booking.read.value' | translate }}</h1>
            </div>

            <div class="col_content y_items_center">

                <!-- Retour à la liste des suivis de commande -->

                <button class="btn_cta btn_lines btn_little" type="button" (click)="redirectToList()">
                    {{ 'booking.list.back.value' | translate }}
                </button>

                <!-- Soumission -->

                <button class="btn_cta btn_little" type="submit" [disabled]="!isSubmitEnabled">
                    {{ 'form.submit.action.value'|translate }}
                </button>

            </div>

        </div>

    </div>

    <!-- Gestion des onglets -->

    <mat-tab-group>
        <mat-tab [label]="'booking.folder.data.value' | translate">
            <ng-container *ngTemplateOutlet="folderData"></ng-container>
        </mat-tab>
        <mat-tab [label]="'booking.folder.data.offer.value' | translate">
            <ng-container *ngTemplateOutlet="offerData"></ng-container>
        </mat-tab>
        <mat-tab [label]="'booking.read.data.stay.value' | translate">
            <ng-container *ngTemplateOutlet="stayData"></ng-container>
        </mat-tab>
        @if(isTypeBooking) {
            <mat-tab [label]="'booking.read.data.pricing.value' | translate">
                <ng-container *ngTemplateOutlet="pricingData"></ng-container>
            </mat-tab>
        }
        @if(hasAccessCustomer) {
            <mat-tab [label]="'booking.read.data.customer.data.value' | translate">
                <ng-container *ngTemplateOutlet="clientData"></ng-container>
            </mat-tab>
        }
        @if(!isInCommercialRelationshipCharge) {
            <mat-tab [label]="'booking.read.data.distributor.contactDetails.value' | translate">
                <ng-container *ngTemplateOutlet="distributorContactDetails"></ng-container>
            </mat-tab>
        }
        @if(!isOfferOwner && (isTypeBooking || (isTypeRequest && hasOneOfThisRoles(['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_OFFER_DISTRIBUTOR'])))) {
            <mat-tab [label]="'booking.read.data.creator.contactDetails.value' | translate">
                <ng-container *ngTemplateOutlet="creatorContactDetails"></ng-container>
            </mat-tab>
        }
    </mat-tab-group>

</form>

<ng-template #folderData>

    <ng-container [formGroup]="form">

        <div class="ligne_form row marges col_12">

            <div class="col_6">

                <div class="form-group">

                    <!-- Statut créateur d'offre-->

                    <div class="ligne_form row_marges">

                        <div class="col_12">

                            <div class="form-group">

                                <select class="form-control" formControlName="status" id="status" required>

                                    @for(item of statusItems; track item) {
                                        <option [value]="item.id">{{ item.label | translate }}</option>
                                    }

                                </select>

                                <label class="required" for="status">{{ 'booking.list.fields.status.creator.value' | translate }}</label>

                                @if(form.get('status').invalid && (form.get('status').dirty || form.get('status').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('status').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>
                    </div>

                    <div class="row marges ligne_form">

                        <div class="col_12">

                            <div class="form-group">

                                <textarea class="form-control" formControlName="comment" id="comment"></textarea>

                                <label for="comment">{{'booking.read.fields.comment.value' | translate}}</label>

                            </div>

                        </div>

                    </div>

                    <div class="ligne_form row marges">

                        <div class="col_12">

                            <div class="form-group">

                                <!-- Société en charge de la relation client -->

                                <p class="read">
                                    <strong>{{ 'booking.read.fields.society.inChargeOfCustomerRelation.value' | translate }} : </strong>
                                    {{ booking.responsibleSociety.name }}
                                </p>

                                @if(booking.responsibleSocietyData?.isDeleted) {

                                    <!-- Ancienne société en charge de la relation client -->

                                    <p class="read">
                                        <strong>{{ 'booking.read.fields.responsibleSocietyData.value' | translate }} : </strong>
                                        {{ booking.responsibleSocietyData.name }} - {{ booking.responsibleSocietyData.phone }} - {{ booking.responsibleSocietyData.email }}
                                    </p>
                                }

                                @if(booking.owner) {

                                    <!-- Collaborateur à l'origine de la demande -->

                                    <p class="read">
                                        <strong>{{ 'booking.read.fields.owner.value' | translate }} : </strong>
                                        {{booking.owner.id}} - {{ booking.owner.firstName }} {{ booking.owner.lastName }} @if(booking.owner.service) {({{ booking.owner.service }})}
                                    </p>
                                }

                            </div>

                        </div>

                    </div>

                    <!-- Collaborateur -->

                    <div class="ligne_form row_marges">

                        <div class="col_12">

                            <div class="form-group">

                                <p class="read">
                                    <strong class="subtitle_green">{{ 'booking.list.fields.responsibleUser.value' | translate }}</strong>
                                </p>

                                <div style="margin-top: 12px">
                                    <app-core-select-search [configuration]="collaboratorSearchConfiguration" [sourceCallback]="collaboratorSearchSourceCallback" [formGroupReference]="form" [formControlNameReference]="'responsibleUser'"></app-core-select-search>
                                </div>

                                @if(currentCollaborator && (currentCollaborator.society.id === booking.responsibleSociety?.id) && hasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR']) && !isUpdateCollaboratorAllowed) {
                                    <mat-error style="padding: 0">
                                        <div class="invalid-feedback">
                                            <div>{{ 'collaborator.update.denied.description.value' | translate }}</div>
                                        </div>
                                    </mat-error>
                                }

                                @if(form.get('responsibleUser').invalid && (form.get('responsibleUser').dirty || form.get('responsibleUser').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('responsibleUser').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }

                            </div>
                        </div>
                    </div>

                    @if(!!currentCollaborator) {

                        <!-- Données du collaborateur -->

                        <div class="ligne_form row marges">

                            <div class="col_12">

                                <div class="form-group">
                                    <p class="read">
                                        <strong class="subtitle_green">{{ 'collaborator.data.plural.value' | translate }}</strong>
                                    </p>

                                </div>
                            </div>
                        </div>

                        <div class="ligne_form row marges">

                            <div class="col_12">

                                <div class="form-group">

                                    <!-- ID -->

                                    @if(currentCollaborator?.id) {

                                        <p class="read">
                                            <strong>{{ 'collaborator.id.value' | translate }} : </strong>
                                            {{ currentCollaborator?.id }}
                                        </p>
                                    }

                                    <!-- Nom -->

                                    @if(currentCollaborator?.firstName || currentCollaborator?.lastName) {

                                        <p class="read">
                                            <strong>{{ 'collaborator.name.value' | translate }} : </strong>
                                            {{ currentCollaborator?.firstName }} {{ currentCollaborator?.lastName }}
                                        </p>
                                    }

                                    <!-- Service -->

                                    @if(currentCollaborator?.service) {

                                        <p class="read">
                                            <strong>{{ 'collaborator.service.value' | translate }} : </strong>
                                            {{ currentCollaborator?.service }}
                                        </p>
                                    }

                                    <!-- Email -->

                                    @if(currentCollaborator?.email) {

                                        <p class="read">
                                            <strong>{{ 'collaborator.email.value' | translate }} : </strong>
                                            {{ currentCollaborator?.email }}
                                        </p>
                                    }

                                    <!-- Téléphone -->

                                    @if(currentCollaborator?.switchboardPhone) {

                                        <p class="read">
                                            <strong>{{ 'collaborator.phone.value' | translate }} : </strong>
                                            {{ currentCollaborator?.switchboardPhone }}
                                        </p>
                                    }

                                    <!-- Adresse -->

                                    @if(currentCollaborator?.address) {

                                        <p class="read">
                                            <strong>{{ 'collaborator.address.value' | translate }} : </strong>
                                            {{ currentCollaborator?.address.address }}, {{ currentCollaborator?.address.zipcode }} {{ currentCollaborator?.address.city }}
                                        </p>
                                    }

                                </div>

                            </div>

                        </div>
                    }

                    @if(booking.offerOwnerSociety?.id !== booking.responsibleSociety?.id) {

                        <!-- Statut distributeur d'offre-->

                        <div class="ligne_form row_marges">
                            <div class="col_12">
                                <div class="form-group">
                                    <select class="form-control" formControlName="distributorStatus" id="distributorStatus" required>
                                        @for(item of statusItems; track item) {
                                            <option [value]="item.id">{{ item.label | translate }}</option>
                                        }
                                    </select>
                                    <label class="required" for="distributorStatus">{{ 'booking.list.fields.status.distributor.value' | translate }}</label>
                                    @if(form.get('distributorStatus').invalid && (form.get('distributorStatus').dirty || form.get('distributorStatus').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(form.get('distributorStatus').errors.required) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>
                            </div>
                        </div>

                        <div class="row marges ligne_form">

                            <div class="col_12">

                                <div class="form-group">

                                    <textarea class="form-control" formControlName="commentResponsibleSociety" id="commentResponsibleSociety"></textarea>

                                    <label for="commentResponsibleSociety">{{'booking.read.fields.commentResponsibleSociety.value' | translate}}</label>

                                </div>

                            </div>

                        </div>
                    }

                </div>

            </div>

        </div>

    </ng-container>

</ng-template>

<ng-template #offerData>

    <div class="ligne_form row marges col_12">

        <div class="col_12">

            <div class="form-group">

                <!-- Nom de l'offre -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.offerName.value' | translate }} : </strong>
                    @if(!!booking.offer) {
                        <a [routerLink]="['/account/offer/read', booking.offer.id]" [queryParams]="{ origin: 'bookingRead', booking: booking.id }">{{ translationService.getFallbackTranslation(booking.offerData.translations).name}}</a>
                    } @else {
                        <span>{{ translationService.getFallbackTranslation(booking.offerData.translations).name}}</span>
                    }
                </p>

            </div>
        </div>
    </div>

    <div class="ligne_form row marges col_12">

        <div class="col_12">

            <div class="form-group">

                <p class="read">
                    <strong>{{ 'booking.read.fields.description.value' | translate }} : </strong>
                </p>

                <div class="read">
                    <div class="txt_offer">
                        <p [innerHTML]="translationService.getFallbackTranslation(booking.offerData.translations).description|safeHtml"></p>
                    </div>
                </div>

                <p class="read">
                    <strong>{{ 'offer.form.fields.included.value' | translate }} : </strong>
                </p>

                <div class="read">
                    @for(included of translatedIncludedsItemFields; track $index) {

                        <div class="txt_offer">

                            <p class="title_2">{{ included?.title }}</p>

                            <p>{{ included?.description }}</p>

                        </div>
                    }
                </div>

                <p class="read">
                    <strong>{{ 'offer.form.fields.included.no.value' | translate }} : </strong>
                </p>

                <div class="read">
                    @for(included of translatedNotIncludedsItemFields; track $index) {

                        <div class="txt_offer little">

                            <p class="title_2">{{ included?.title }}</p>

                            <p>{{ included?.description }}</p>

                        </div>
                    }
                </div>

                @if(translationService.getFallbackTranslation(booking.offerData.translations).accommodation?.length) {

                    <p class="read">
                        <strong>{{ 'offer.form.fields.accommodation.value' | translate }} : </strong>
                    </p>

                    <div class="read">
                        <div class="txt_offer">
                            <p [innerHTML]="translationService.getFallbackTranslation(booking.offerData.translations).accommodation|safeHtml"></p>
                        </div>
                    </div>
                }

            </div>
        </div>
    </div>

</ng-template>

<ng-template #stayData>

    <!-- Données Générales -->

    <div class="ligne_form row marges col_12">

        <div class="col_12">

            <div class="form-group">

                @if(isTypeRequest && (booking.referenceResponsibleSociety !== null)) {

                    <!-- Référence distributeur demande de devis -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.referenceResponsibleSociety.value' | translate }} : </strong>
                        {{booking.referenceResponsibleSociety}}
                    </p>
                }

                <!-- N° de dossier -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.reference.value' | translate }} : </strong>
                    {{booking.reference}}
                </p>

                @if(isTypeBooking && booking.giftVoucher) {

                    <!-- Bon cadeau Oui / Non -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.giftVoucher.value' | translate }} : </strong>
                        {{  'booking.read.fields.giftVoucher.isGiftVoucher.' + (booking.giftVoucher ? 'yes' : 'no') + '.value' | translate }}
                    </p>

                    <p class="read">
                        <strong>{{ 'giftVoucher.read.fields.code.value' | translate }} : </strong>
                        {{ booking.giftVoucher.code }}
                    </p>
                }

                <!-- Date de la demande -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.createdAt.value' | translate }} : </strong>
                    {{ (booking.createdAt | date : 'fullDate' : null: localeId) | titlecase }}
                </p>

                <!-- Type de demande -->

                <p class="read">
                    <strong>{{ 'booking.read.fields.type.value' | translate }} : </strong>
                    @if(!booking.giftVoucher && !isOnlineSale) {
                        {{ 'booking.type.' + booking.type + '.value' | translate }}
                    }
                    @if(isOnlineSale) {
                        {{ 'booking.type.onlineSale.value' | translate }}
                    }
                    @if(booking.giftVoucher && !booking.hasStock) {
                        {{ 'booking.read.fields.giftVoucher.value' | translate }}
                    }
                </p>

                <p class="read">
                    <strong>{{ 'booking.read.fields.offerName.value' | translate }} : </strong>
                    <span>{{ translationService.getFallbackTranslation(booking.offerData.translations).name}}</span>
                </p>

                @if(isTypeRequest) {

                    <!-- Langue parlée par le client -->

                    @if(hasAccessCustomer) {

                        <p class="read">
                            <strong>{{ 'booking.read.fields.customer.language.spoken.value' | translate }} : </strong>
                            {{ booking.customer.spokenLanguage }}
                        </p>
                    }

                    <!-- Budget par personne -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.budget.perPerson.value' | translate }} : </strong>
                        {{booking.composition.budget}} {{ booking.composition.currency.symbol }} @if(booking.composition.isFlexibleBudget !== null) {({{ (booking.composition.isFlexibleBudget ? 'booking.read.fields.budget.type.flexible.value' : 'booking.read.fields.budget.type.fixed.value') | translate }})}
                    </p>

                    <!-- Project client -->

                    @if(hasAccessCustomer) {
                        <p class="read">
                            <strong>{{ 'booking.read.fields.client.project.value' | translate }} : </strong>
                            {{ booking.customer.comment }}
                        </p>
                    }
                }

                @if(isTypeBooking && hasAccessCustomer && booking.customer.comment?.length) {

                    <!-- Commentaire client -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.customerComment.value' | translate }} : </strong>
                        {{ booking.customer.comment }}
                    </p>
                }

            </div>
        </div>
    </div>

    <!-- Données Séjour -->

    <div class="ligne_form row marges col_12">

        <div class="col_12">

            <div class="form-group">

                <p class="read">
                    <strong class="subtitle_green">{{ 'booking.read.title.stay' | translate }}</strong>
                </p>

            </div>
        </div>
    </div>

    <div class="ligne_form row marges col_12">

        <div class="col_12">

            <div class="form-group">

                @if(booking.composition) {

                    <div class="row marges ligne_form">

                        <div class="col_12 y_content_start">

                            <div>

                                <!-- Date de début de séjour -->

                                <p class="read">
                                    <strong>{{ 'booking.read.fields.date.start.value' | translate }} : </strong>
                                    {{ (composition.dateStart | date : 'fullDate' : null: localeId) | titlecase }}
                                </p>

                                <!-- Date de fin de séjour -->

                                <p class="read">
                                    <strong>{{ 'booking.read.fields.date.end.value' | translate }} : </strong>
                                    {{ (composition.dateEnd | date : 'fullDate' : null : localeId) | titlecase }}
                                </p>

                                @if(isTypeRequest) {

                                    <!-- Flexibilité -->

                                    <p class="read">
                                        <strong>{{ 'booking.read.fields.flexibility.value' | translate }} : </strong>
                                        {{ translationService.getFallbackTranslation(booking.composition.flexibility.translations).label }}
                                    </p>
                                }

                                <!-- Nombre d'adultes -->

                                <p class="read">
                                    <strong>{{ 'booking.read.fields.adult.count.value' | translate }} : </strong>
                                    {{ composition.nbAdult || 0 }}
                                </p>

                                <!-- Nombre d'enfants -->

                                <p class="read">
                                    <strong>{{ 'booking.read.fields.child.count.value' | translate }} : </strong>
                                    {{ composition.nbChild || 0 }}
                                </p>
                            </div>
                        </div>
                    </div>
                }

                <!-- Données Participants -->

                @if(composition && participants.length) {

                    <div class="ligne_form row marges col_12">

                        <div class="col_12">

                            <div class="form-group">

                                <p class="read">
                                    @if(isTypeBooking) {
                                        <strong class="subtitle_green">{{ 'booking.read.title.participant.plural.value' | translate }}</strong>
                                    }
                                    @if(isTypeRequest) {
                                        <strong class="subtitle_green">{{ 'booking.read.title.participant.children.plural.value' | translate }}</strong>
                                    }
                                </p>

                            </div>
                        </div>
                    </div>

                    <div class="ligne_form row marges col_12">

                        <div class="col_12">

                            <div class="form-group">

                                <div class="row marges">

                                    @for(participant of participants; track participant) {

                                        <div class="col_3 y_content_start">

                                            <div class="read_composition_option" style="width: 100%">

                                                @if(isTypeBooking) {

                                                    <!-- Type -->

                                                    <p class="read">
                                                        <strong>{{ 'type.value' | translate }} : </strong>
                                                        {{ (participant.type + '.value') | translate }}
                                                    </p>

                                                    <!-- Nom -->

                                                    @if(participant.lastName) {

                                                        <p class="read">
                                                            <strong>{{ 'user.lastName.value' | translate }} : </strong>
                                                            {{ participant.lastName }}
                                                        </p>
                                                    }

                                                    <!-- Prénom -->

                                                    @if(participant.firstName) {

                                                        <p class="read">
                                                            <strong>{{ 'user.firstName.value' | translate }} : </strong>
                                                            {{ participant.firstName }}
                                                        </p>
                                                    }
                                                }

                                                <!-- Date de naissance -->

                                                @if(participant.birthDay) {

                                                    <p class="read">
                                                        <strong>{{ 'offer.form.fields.birthdate.value' | translate }} : </strong>
                                                        {{ (participant.birthDay | date : 'fullDate' : null: localeId) | titlecase }}
                                                    </p>
                                                }

                                            </div>

                                        </div>
                                    }

                                </div>

                            </div>

                        </div>

                    </div>
                }

                @if(composition.permanentOptions.length || (!composition.permanentOptions.length && booking.optoutPermanentOptions)) {

                    <div class="row marges ligne_form">

                        <div class="col_12 y_content_start">

                            <div>

                                <!-- Option Permanentes -->

                                @if(composition.permanentOptions.length) {

                                    <p class="read">
                                        <strong class="subtitle_green">{{ 'booking.read.title.permanentOptionData' | translate }}</strong>
                                    </p>

                                    <br>

                                    @for(compositionPermanentOption of composition.permanentOptions; track compositionPermanentOption) {

                                        <div class="read_composition_option">

                                            <!-- Nom -->

                                            <p class="read">
                                                <strong>{{ 'booking.read.fields.compositionPermanentOption.permanentOption.name.value' | translate }} : </strong>
                                                {{ translationService.getFallbackTranslation(compositionPermanentOption.permanentOptionData.translations).title }} @if(compositionPermanentOption.permanentOptionData.reference !== null) {({{ compositionPermanentOption.permanentOptionData.reference }})}
                                            </p>

                                            <!-- Nombre d'adulte(s) -->

                                            <p class="read">
                                                <strong>{{ 'booking.read.fields.adult.count.value' | translate }} : </strong>
                                                {{ composition.nbAdult || 0 }}
                                            </p>

                                            <!-- Nombre d'enfant(s) -->

                                            <p class="read">
                                                <strong>{{ 'booking.read.fields.child.count.value' | translate }} : </strong>
                                                {{ composition.nbChild || 0 }}
                                            </p>

                                            <!-- Prix -->

                                            @if(compositionPermanentOption.priceTTC) {

                                                <p class="read">
                                                    <strong>{{ 'booking.read.fields.compositionPermanentOption.permanentOption.price.ttc.value' | translate }} : </strong>
                                                    {{ parsePriceTTC(compositionPermanentOption.priceTTC, composition.currency) }}

                                                    @if(booking.type === 'booking' && !! compositionPermanentOption.priceHT) {

                                                        ({{ parsePriceHT(compositionPermanentOption.priceHT, composition.currency) }})
                                                    }
                                                </p>
                                            }

                                            <!-- Option sur devis sans tarif défini -->

                                            @if(compositionPermanentOption.onRequest) {
                                                <p class="read">
                                                    <strong>{{ 'booking.read.fields.compositionPermanentOption.permanentOption.onRequest.value' | translate }}</strong>
                                                </p>
                                            }

                                        </div>
                                    }
                                }

                                @if(!composition.permanentOptions.length && booking.optoutPermanentOptions) {

                                    <p class="read">
                                        <strong class="subtitle_green">{{ 'booking.read.title.permanentOptionData' | translate }}</strong>
                                    </p>

                                    <p class="read">
                                        {{ 'booking.read.optoutPermanentOptions.checked.value' | translate }}
                                    </p>
                                }
                            </div>

                        </div>

                    </div>
                }

            </div>

        </div>

    </div>

</ng-template>

<ng-template #pricingData>

    <!-- Promotion appliquée -->

    @if(promotionDisplayed) {

        <div class="ligne_form row marges col_12">
            <div class="col_12">
                <div class="form-group">
                    <p class="read">
                        <strong class="subtitle_green">{{ 'promotion.value' | translate }}</strong>
                    </p>
                </div>
            </div>
        </div>

        <div class="ligne_form row marges col_12">

            <div class="col_12">

                <div class="form-group">

                    @if(booking.promotionData) {

                        <p class="read">
                            <strong>{{ 'booking.read.fields.promotion.code.value' | translate }} : </strong>
                            <span>{{ booking.promotionData.code }}</span>
                        </p>

                        <p class="read">
                            <strong>{{ 'booking.read.fields.promotionCode.value' | translate }} : </strong>
                            <span>{{ getPromotion(booking.promotionData) }}</span>
                        </p>
                    }

                    @if(composition.promotionOfferCreatorData) {

                        <p class="read">
                            <strong>{{ 'booking.read.fields.promotion.value' | translate }} : </strong>
                            <span>{{ getPromotion(composition.promotionOfferCreatorData) }}</span>
                        </p>
                    }

                    @if(composition.promotionDistributorData) {

                        <p class="read">
                            <strong>{{ 'booking.read.fields.promotion.value' | translate }} : </strong>
                            <span>{{ getPromotion(composition.promotionDistributorData) }}</span>
                        </p>
                    }

                </div>
            </div>
        </div>
    }

    <!-- Montants total du dossier -->

    @if(amountDisplayed) {

        <div class="ligne_form row marges col_12">
            <div class="col_12">
                <div class="form-group">
                    <p class="read">
                        <strong class="subtitle_green">{{ 'booking.read.fields.amount.plural.total.value' | translate }}</strong>
                    </p>
                </div>
            </div>
        </div>

        <div class="ligne_form row marges col_12">

            <div class="col_12">

                <div class="form-group">

                    <!-- Montant public TTC du dossier (assurances incluses) -->

                    @if(composition.totalPriceTTC) {
                        <p class="read">
                            <strong>{{ (composition.permanentOptions.length ? 'booking.read.fields.price.ttc.with_permanent_option.value' : 'booking.read.fields.price.ttc.value') | translate }} : </strong>
                            <span>{{ parsePriceTTC(composition.totalPriceTTC, composition.currency) }}@if(hasOnePermanentOptionOnRequest) { ({{ 'booking.read.fields.price.permanentOption.onRequest.value' | translate }})}</span>
                        </p>
                    }

                    <!-- Montant net TTC du dossier (hors assurance) -->

                    @if((userService.isCurrentUserAdmin || isInCommercialRelationshipCharge || isOfferOwner) && composition.netPriceTTC) {

                        <p class="read">
                            <strong>{{ 'booking.read.fields.price.net.ttc.value' | translate }} : </strong>
                            <span>{{ parsePriceTTC(composition.netPriceTTC, composition.currency) }}</span>
                        </p>
                    }
                </div>
            </div>
        </div>
    }

    <!-- Markup -->

    @if((userService.isCurrentUserAdmin || isInCommercialRelationshipCharge) && composition.markup) {

        <div class="ligne_form row marges col_12">
            <div class="col_12">
                <div class="form-group">
                    <p class="read">
                        <strong class="subtitle_green">{{ 'booking.read.fields.markup.title.value' | translate }}</strong>
                    </p>
                </div>
            </div>
        </div>

        <div class="ligne_form row marges col_12">

            <div class="col_12">

                <div class="form-group">

                    <!-- Markup en pourcentage -->

                    @if(composition.markup) {

                        <p class="read">
                            <strong>{{ 'booking.read.fields.markup.value' | translate }} : </strong>
                            <span>{{ parsedMarkup(composition.markup) }}</span>
                        </p>
                    }

                    <!-- Markup : Montant HT -->

                    @if(composition.markupPriceHT) {

                        <p class="read">
                            <strong>{{ 'booking.read.fields.markup.price.ht.value' | translate }} : </strong>
                            <span>{{ parsePriceHT(composition.markupPriceHT, composition.currency) }}</span>
                        </p>
                    }

                    <!-- Markup : Montant TTC -->

                    @if(composition.markupPriceTTC) {

                        <p class="read">
                            <strong>{{ 'booking.read.fields.markup.price.ttc.value' | translate }} : </strong>
                            <span>{{ parsePriceTTC(composition.markupPriceTTC, composition.currency) }}</span>
                        </p>
                    }

                </div>
            </div>
        </div>
    }

    <!-- Commission Ty-Win -->

    @if(tywinCommissionDisplayed) {

        <div class="ligne_form row marges col_12">
            <div class="col_12">
                <div class="form-group">
                    <p class="read">
                        <strong class="subtitle_green">{{ 'tywin.commission.value' | translate }}</strong>
                    </p>
                </div>
            </div>
        </div>

        <div class="ligne_form row marges col_12">

            <div class="col_12">

                <div class="form-group">

                    <!-- % (HT) de commission Ty-win -->

                    @if(userService.isCurrentUserAdmin || userService.hasOneOfThisRoles(userService.currentUser.getValue(), ['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])) {

                        @if(userService.isCurrentUserAdmin) {

                            <p class="read">
                                <strong>{{ 'booking.read.fields.commission.internal.offerCreator.value' | translate }} : </strong>
                                <span>{{ composition.offerOwnerInternalCommission ? parsePercent(composition.offerOwnerInternalCommission * 100) : 'N/A' }}</span>
                            </p>

                            <p class="read">
                                <strong>{{ 'booking.read.fields.commission.internal.distributor.value' | translate }} : </strong>
                                <span>{{ composition.internalCommission ? parsePercent(composition.internalCommission * 100) : 'N/A' }}</span>
                            </p>

                        } @else {

                            @if(isOfferOwner) {

                                <p class="read">
                                    <strong>{{ 'booking.read.fields.commission.internal.value' | translate }} : </strong>
                                    <span>{{ composition.offerOwnerInternalCommission ? parsePercent(composition.offerOwnerInternalCommission * 100) : 'N/A' }}</span>
                                </p>

                            }

                            @if(!isOfferOwner && isInCommercialRelationshipCharge) {

                                <p class="read">
                                    <strong>{{ 'booking.read.fields.commission.internal.value' | translate }} : </strong>
                                    <span>{{ composition.internalCommission ? parsePercent(composition.internalCommission * 100) : 'N/A' }}</span>
                                </p>
                            }
                        }
                    }

                    <!-- Montant (HT) de commission Ty-Win -->

                    @if(userService.isCurrentUserAdmin || userService.hasOneOfThisRoles(userService.currentUser.getValue(), ['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])) {

                        @if(userService.isCurrentUserAdmin) {

                            <p class="read">
                                <strong>{{ 'booking.read.fields.commission.internal.amount.offerCreator.value' | translate }} : </strong>
                                <span>{{ composition.amountOfferOwnerInternalCommission ? parsePriceHT(composition.amountOfferOwnerInternalCommission, composition.currency) : 'N/A' }}</span>
                            </p>

                            <p class="read">
                                <strong>{{ 'booking.read.fields.commission.internal.amount.distributor.value' | translate }} : </strong>
                                <span>{{ composition.amountInternalCommission ? parsePriceHT(composition.amountInternalCommission, composition.currency) : 'N/A' }}</span>
                            </p>

                        } @else {

                            @if(isOfferOwner) {

                                <p class="read">
                                    <strong>{{ 'booking.read.fields.commission.internal.amount.value' | translate }} : </strong>
                                    <span>{{ composition.amountOfferOwnerInternalCommission ? parsePriceHT(composition.amountOfferOwnerInternalCommission, composition.currency) : 'N/A' }}</span>
                                </p>
                            }

                            @if(!isOfferOwner && isInCommercialRelationshipCharge) {

                                <p class="read">
                                    <strong>{{ 'booking.read.fields.commission.internal.amount.value' | translate }} : </strong>
                                    <span>{{ composition.amountInternalCommission ? parsePriceHT(composition.amountInternalCommission, composition.currency) : 'N/A' }}</span>
                                </p>
                            }
                        }
                    }

                </div>
            </div>
        </div>
    }

    <!-- Frais de transaction MangoPay -->

    @if(feesDisplayed) {

        <div class="ligne_form row marges col_12">
            <div class="col_12">
                <div class="form-group">
                    <p class="read">
                        <strong class="subtitle_green">{{ 'mangopay.fees.plural.amount.value' | translate }}</strong>
                    </p>
                </div>
            </div>
        </div>

        <div class="ligne_form row marges col_12">

            <div class="col_12">

                <div class="form-group">

                    <!-- % (HT) Frais de transaction MangoPay applicable sur Montant Public TTC du dossier -->

                    @if(userService.isCurrentUserAdmin || userService.hasOneOfThisRoles(userService.currentUser.getValue(), ['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])) {

                        @if(userService.isCurrentUserAdmin || isInCommercialRelationshipCharge) {

                            <p class="read">
                                <strong>{{ 'booking.read.fields.paymentFees.value' | translate }} : </strong>
                                <span>{{ composition.paymentFees ? parsePercent(composition.paymentFees * 100) : 'N/A' }}</span>
                            </p>
                        }
                    }

                    <!-- Montant (HT) des frais de transaction MangoPay -->

                    @if(userService.isCurrentUserAdmin || userService.hasOneOfThisRoles(userService.currentUser.getValue(), ['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])) {

                        <p class="read">
                            <strong>{{ 'booking.read.fields.paymentFees.amount.value' | translate }} : </strong>
                            <span>{{ composition.amountPaymentFees ? parsePriceHT(composition.amountPaymentFees, composition.currency) : 'N/A' }}</span>
                        </p>
                    }

                </div>

            </div>

        </div>
    }

    <!-- Commission apporteurs d’affaires -->

    @if(businessProviderFeesDisplayed) {

        <div class="ligne_form row marges col_12">
            <div class="col_12">
                <div class="form-group">
                    <p class="read">
                        <strong class="subtitle_green">{{ 'businessProvider.plural.commission.value' | translate }}</strong>
                    </p>
                </div>
            </div>
        </div>

        <div class="ligne_form row marges col_12">

            <div class="col_12">

                <div class="form-group">

                    <!-- % (HT) Commission distributeur applicable sur Montant net TTC du dossier -->

                    @if(userService.hasOneOfThisRoles(userService.currentUser.getValue(), ['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION']) && composition.commission) {

                        <p class="read">
                            <strong>{{ 'booking.read.fields.commission.value' | translate }} : </strong>
                            <span>{{ parsePercent(composition.commission * 100) }}</span>
                        </p>
                    }

                    <!-- Montant (HT) de la commission distributeur -->

                    @if(composition.amountCommission) {

                        <p class="read">
                            <strong>{{ 'booking.read.fields.commission.amount.value' | translate }} : </strong>
                            <span>{{ parsePriceHT(composition.amountCommission, composition.currency) }}</span>
                        </p>
                    }

                    <!-- Encaissement de la commission -->

                    @if(userService.isCurrentUserAdmin || userService.hasOneOfThisRoles(userService.currentUser.getValue(), ['ROLE_OFFER_CREATOR'])) {

                        @if(composition.commissionPaymentStatus === 'paid') {

                            <p class="read">
                                <strong>{{ 'booking.read.fields.commission.receipt.value' | translate }} : </strong>
                                <span>{{ 'yes.value' | translate }}</span>
                            </p>
                        }
                    }

                </div>
            </div>
        </div>
    }

    <div class="row ligne_form">
        <div class="col_12">
            <div class="form-group">
                <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon><span>{{ 'booking.data.pricing.description.value' | translate }}</span></span>
            </div>
        </div>
    </div>

</ng-template>

<ng-template #distributorContactDetails>

    <ng-container [formGroup]="form">

        <div class="ligne_form row">

            <div class="col_12">

                <div class="form-group">

                    <!-- Nom du canal -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.channelName.value' | translate }} : </strong>
                        {{ booking.channel ? translationService.getFallbackTranslation(booking.channel.translations).name : ( booking.giftVoucher ? ('booking.read.fields.channelName.giftVoucher.value' | translate) : ('booking.read.fields.channelName.none.value' | translate))}}
                    </p>

                    <!-- Site internet -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.channelMarketplace.value' | translate }} : </strong>
                        @if ((booking.channel?.marketplace ? booking.channel.marketplace.website : (booking.giftVoucher ? giftVoucherUrl : originUrl)); as website) {
                            <a class="link_text" href="{{ website | externalUrl }}" target="_blank">{{ website }}</a>
                        }
                    </p>

                    <!-- Nom du propriétaire du canal -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.channel.owner.name.value' | translate }} : </strong>
                        {{ booking.channel ? booking.channel.society.name : booking.responsibleSociety.name }}
                    </p>

                    <!-- Email du propriétaire du canal -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.channel.owner.email.value' | translate }} : </strong>
                        {{ booking.channel ? booking.channel.society.email : booking.responsibleSociety.email }}
                    </p>

                    <!-- Téléphone du propriétaire du canal -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.channel.owner.phone.value' | translate }} : </strong>
                        {{ booking.channel ? booking.channel.society.phone : booking.responsibleSociety.phone }}
                    </p>

                </div>

            </div>

        </div>

    </ng-container>

</ng-template>

<ng-template #creatorContactDetails>

    <div class="ligne_form row">

        <div class="col_12">

            <div class="form-group">

                <!-- Nom du créateur d'offre -->

                @if(booking.offerData.societyName) {
                    <p class="read">
                        <strong>{{ 'booking.read.fields.offerProductor.value' | translate }} : </strong>
                        {{ booking.offerData.societyName }}
                    </p>
                }

                <!-- Email du créateur d'offre -->

                @if(booking.offerData.societyEmail) {
                    <p class="read">
                        <strong>{{ 'booking.read.fields.offerProductor.email.value' | translate }} : </strong>
                        {{ booking.offerData.societyEmail }}
                    </p>
                }

                <!-- Téléphone du créateur d'offre -->

                @if(booking.offerData.societyPhone) {
                    <p class="read">
                        <strong>{{ 'booking.read.fields.offerProductor.phone.value' | translate }} : </strong>
                        {{ booking.offerData.societyPhone }}
                    </p>
                }

            </div>

        </div>

    </div>

</ng-template>

<ng-template #clientData>

    <div class="ligne_form row marges col_12">

        <div class="col_12">

            <div class="form-group">

                @if(booking.customer.society) {

                    <!-- Nom de la structure -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.customerSociety.value' | translate }} : </strong>
                        {{ booking.customer.society }}@if(booking.customer.customerType) { ({{ translationService.getFallbackTranslation(booking.customer.customerType.translations).label }})}
                    </p>
                }

                @if(booking.customer.civility !== null) {

                    <!-- Civilité -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.civility.value' | translate }} : </strong>
                        {{ (booking.customer.civility === 1 ? 'form.user.fields.civility.mister.value' : 'form.user.fields.civility.madam.value') | translate }}
                    </p>
                }

                @if(booking.customer.lastName) {

                    <!-- Nom -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.customerName.value' | translate }} : </strong>
                        {{ booking.customer.lastName }}
                    </p>
                }

                @if(booking.customer.firstName) {

                    <!-- Prénom -->

                    <p class="read">
                        <strong>{{ 'booking.read.fields.customerFirstName.value' | translate }} : </strong>
                        {{ booking.customer.firstName }}
                    </p>
                }

                @if(displayCustomerAddress) {

                    @if(booking.customer.address) {

                        <!-- Adresse -->

                        <p class="read">
                            <strong>{{ 'booking.read.fields.customerAddress.value' | translate }} : </strong>
                            {{ booking.customer.address }}
                        </p>
                    }

                    @if(booking.customer.additionalAddress) {

                        <!-- Complément d'adresse -->

                        <p class="read">
                            <strong>{{ 'booking.read.fields.customerAdditionalAddress.value' | translate }} : </strong>
                            {{ booking.customer.additionalAddress }}
                        </p>
                    }

                    @if(booking.customer.zipcode) {

                        <!-- Code postal -->

                        <p class="read">
                            <strong>{{ 'booking.read.fields.customerZipcode.value' | translate }} : </strong>
                            {{ booking.customer.zipcode }}
                        </p>
                    }

                    @if(booking.customer.city) {

                        <!-- Ville -->

                        <p class="read">
                            <strong>{{ 'booking.read.fields.customerCity.value' | translate }} : </strong>
                            {{ booking.customer.city }}
                        </p>
                    }

                    @if(booking.customer.region) {

                        <!-- Région -->

                        <p class="read">
                            <strong>{{ 'booking.read.fields.customerRegion.value' | translate }} : </strong>
                            {{ booking.customer.region }}
                        </p>
                    }

                    @if(booking.customer.country) {

                        <!-- Pays -->

                        <p class="read">
                            <strong>{{ 'booking.read.fields.customerCountry.value' | translate }} : </strong>
                            {{ getCountryTranslation(booking.customer.country)?.name }}
                        </p>
                    }

                    @if(booking.customer.email) {

                        <!-- Email -->

                        <p class="read">
                            <strong>{{ 'booking.read.fields.customerEmail.value' | translate }} : </strong>
                            {{ booking.customer.email }}
                        </p>
                    }

                    @if(booking.customer.phone) {

                        <!-- Téléphone -->

                        <p class="read">
                            <strong>{{ 'booking.read.fields.customerFirstPhone.value' | translate }} : </strong>
                            {{ booking.customer.phone }}
                        </p>
                    }

                    @if(booking.customer.spokenLanguage) {

                        <!-- Langue parlée -->

                        <p class="read">
                            <strong>{{ 'booking.read.fields.language.spoken.value' | translate }} : </strong>
                            {{ ('locale.' + booking.customer.spokenLanguage + '.value') | translate }}
                        </p>
                    }

                    @if(booking.customer.hasOtherSpokenLanguages) {

                        <!-- Autres langues parlées -->

                        <p class="read">
                            <strong>{{ (booking.customer.spokenLanguage === null ? 'booking.read.fields.language.spoken.value' : 'language.plural.spoken.other.value') | translate }} : </strong>
                            {{ booking.customer.otherSpokenLanguages }}
                        </p>
                    }
                }

            </div>

        </div>

    </div>

</ng-template>
